<script setup lang="ts">
const props = defineProps<{
  buttonText: string;
}>();
</script>

<template>
  <div :class="$style.advertising__wrapper">
    <div :class="$style.advertising__wrapper__information">
      <div :class="$style.advertising__wrapper__subtitle">
        По вопросам размещения рекламы обращайтесь по почте или телефону
      </div>
      <div :class="$style.advertising__wrapper__content">
        <div :class="$style.advertising__wrapper__block">
          <div :class="$style.advertising__wrapper__name">Почта</div>
          <div :class="$style.advertising__wrapper__link">
            <Icon name="my-icon:i-mail" size="20px"></Icon>
            <a href="mailto:sales@cre.ru" class="advertising__wrapper__mail"
              >sales@cre.ru</a
            >
          </div>
        </div>
        <div :class="$style.advertising__wrapper__block">
          <div :class="$style.advertising__wrapper__name">Телефон</div>
          <div :class="$style.advertising__wrapper__link">
            <Icon name="my-icon:i-call" size="20px"></Icon>
            <a href="tel:+74950858818">+7 (495) 085-88-18</a>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.advertising__wrapper__action">
      <div :class="$style.advertising__wrapper_button">
        {{ props.buttonText }}
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.advertising__wrapper {
  display: flex;
  border: 1px solid var(--color-gray-line);
  margin: 0 var(--space-2-5x);

  &__information {
    width: 623px;
    border-right: 1px solid var(--color-gray-line);
  }

  &__subtitle {
    @include text_body1_medium;
    color: var(--color-black-1);
    padding: var(--space-2-5x);
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__content {
    display: flex;
  }

  &__block {
    padding: var(--space-2-5x);
    width: 100%;
  }

  &__block:first-child {
    border-right: 1px solid var(--color-gray-line);
  }

  &__name {
    @include text_caption1_caps;
    color: var(--color-gray-text);
    margin-bottom: var(--space-0-5x);
  }

  &__link {
    display: flex;
    align-items: center;
    gap: var(--space-1x);
    a {
      @include text_caption1_caps;
      text-decoration: none;
      color: var(--color-red-1);
    }

    path {
      fill: var(--color-red-1);
    }
  }

  &__action {
    padding: var(--space-2-5x);
    display: flex;
    align-items: center;
    width: 417px;
  }

  &_button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @include text_button1;
    height: 60px;
    background: var(--color-black);
    color: var(--color-white);
    padding: 16px 32px;
  }
}

@media (max-width: 1379px) {
  .advertising__wrapper {
    flex-direction: column;
    margin: 0 var(--space-2x);
    &__information {
      width: 100%;
      border-right: 0;
      border-bottom: 1px solid var(--color-gray-line);
    }

    &__action {
      width: 100%;
    }
  }
}

@media (max-width: 767px) {
  .advertising__wrapper {
    &__content {
      flex-direction: column;
    }

    &__block:first-child {
      border-right: 0;
      border-bottom: 1px solid var(--color-gray-line);
    }
  }
}
</style>
